






















import { Component, Vue } from 'vue-property-decorator';
import LoadingSpinner from '@/shared/components/loadingSpinner/LoadingSpinner.vue';

@Component({
	components: {
		LoadingSpinner
	},
})
export default class PrivateApps extends Vue {
	public isLoading: boolean = true;

	public loading() {
		this.isLoading = true;
	}
	public loaded() {
		this.isLoading = false;
	}
}
